import { Component } from 'react'

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { error: null, componentStack: null }
  }

  static getDerivedStateFromError(error) {
    return { error }
  }

  componentDidCatch(error, info) {
    this.setState({ componentStack: info?.componentStack ?? null })
    console.error('[ErrorBoundary]', error, info?.componentStack)
  }

  render() {
    if (this.state.error) {
      return (
        <div style={{
          minHeight: '100dvh', display: 'flex', alignItems: 'center', justifyContent: 'center',
          background: '#0C0F14', padding: '24px',
        }}>
          <div style={{
            maxWidth: '640px', width: '100%', background: '#141820',
            border: '1px solid rgba(255,255,255,0.07)', borderRadius: '12px', padding: '24px',
          }}>
            <p style={{ color: '#f87171', fontWeight: 600, marginBottom: '8px' }}>
              Application error
            </p>
            <pre style={{
              color: '#94A3B8', fontSize: '12px', whiteSpace: 'pre-wrap', wordBreak: 'break-all',
              background: '#0C0F14', padding: '12px', borderRadius: '8px', marginBottom: '8px',
            }}>
              {this.state.error.message}{'\n\n'}{this.state.error.stack}
            </pre>
            {this.state.componentStack && (
              <>
                <p style={{ color: '#64748b', fontSize: '11px', fontWeight: 600, marginBottom: '4px' }}>
                  Component stack:
                </p>
                <pre style={{
                  color: '#64748b', fontSize: '11px', whiteSpace: 'pre-wrap', wordBreak: 'break-all',
                  background: '#0C0F14', padding: '12px', borderRadius: '8px',
                }}>
                  {this.state.componentStack}
                </pre>
              </>
            )}
            <button
              onClick={() => window.location.href = '/'}
              style={{
                marginTop: '16px', padding: '8px 16px', background: '#4f46e5',
                color: '#fff', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '14px',
              }}
            >
              Reload
            </button>
          </div>
        </div>
      )
    }
    return this.props.children
  }
}
